module.exports = __webpack_public_path__ + "static/media/attendees.4493248a.svg";